module.exports = __webpack_public_path__ + "static/media/iceberg_pouch.6ba0117b.webp";